import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CustomAuthProvider } from './contexts/CustomAuthContext';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';
import ProtectedRoute from './components/Helper/ProtectedRoute';
import FeatureGatedRoute from './components/Helper/FeatureGatedRoute';
import Layout from './components/MainPage/Layout';
import Login from './components/Zitadel-Auth/Login';
import Register from './components/Zitadel-Auth/Register';
import ForgotPassword from './components/Administration/ForgotPassword';
import ResetPassword from './components/Zitadel-Auth/ResetPassword';
import VerifyEmail from './components/Zitadel-Auth/VerifyEmail';
import TOTPSetup from './components/Zitadel-Auth/TOTPSetup';
import HomePage from './components/MainPage/HomePage';
import DataShowcase from './components/Price-History/DataShowcase';
import SubmitData from './components/Price-History/SubmitData';
import ReviewSubmissions from './components/Price-History/ReviewSubmissions';
import AdminPanel from './components/Administration/AdminPanel';
import MapRegionEditor from './components/Map/MapRegionEditor';
import Profile from './components/MainPage/Profile';
import Impressum from './components/MainPage/Impressum';
import FAQ from './components/MainPage/FAQ';
import DiscordDashboard from './components/Discord/DiscordDashboard';
import DiscordServerSettings from './components/Discord/DiscordServerSettings';
import InteractiveMap from './components/Map/InteractiveMap';
import DamageCalculator from './components/Damage-Calc/DamageCalculator';
import './App.css';

function App() {
  return (
    <CustomAuthProvider>
      <FeatureFlagsProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* ── Home / Landing page ── */}
              <Route
                path="/"
                element={
                  <Layout>
                    <HomePage />
                  </Layout>
                }
              />

              {/* ── Price History (previously the default "/") ── */}
              <Route
                path="/price-history"
                element={
                  <FeatureGatedRoute featureKey="feature_page_price_history">
                    <Layout>
                      <DataShowcase />
                    </Layout>
                  </FeatureGatedRoute>
                }
              />

              {/* ── FAQ / Info ── */}
              <Route
                path="/faq"
                element={
                  <Layout>
                    <FAQ />
                  </Layout>
                }
              />

              {/* ── Map ── */}
              <Route
                path="/map"
                element={
                  <FeatureGatedRoute featureKey="feature_page_map">
                    <InteractiveMap />
                  </FeatureGatedRoute>
                }
              />

              {/* ── Damage Calculator ── */}
              <Route
                path="/damage-calculator"
                element={
                  <FeatureGatedRoute featureKey="feature_page_damage_calc">
                    <DamageCalculator />
                  </FeatureGatedRoute>
                }
              />

              {/* ── Impressum ── */}
              <Route
                path="/impressum"
                element={
                  <Layout>
                    <Impressum />
                  </Layout>
                }
              />

              {/* ── Authentication Routes – no layout wrapper ── */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route
                path="/setup-totp"
                element={
                  <ProtectedRoute>
                    <TOTPSetup />
                  </ProtectedRoute>
                }
              />

              {/* ── Protected Routes – require login ── */}
              <Route
                path="/submit-data"
                element={
                  <FeatureGatedRoute featureKey="feature_page_submit">
                    <Layout>
                      <ProtectedRoute>
                        <SubmitData />
                      </ProtectedRoute>
                    </Layout>
                  </FeatureGatedRoute>
                }
              />
              <Route
                path="/review-submissions"
                element={
                  <Layout>
                    <ProtectedRoute>
                      <ReviewSubmissions />
                    </ProtectedRoute>
                  </Layout>
                }
              />
              <Route
                path="/admin-panel"
                element={
                  <Layout>
                    <ProtectedRoute>
                      <AdminPanel />
                    </ProtectedRoute>
                  </Layout>
                }
              />
              <Route
                path="/admin/map-region-editor"
                element={
                  <Layout>
                    <ProtectedRoute>
                      <MapRegionEditor />
                    </ProtectedRoute>
                  </Layout>
                }
              />
              <Route
                path="/profile"
                element={
                  <Layout>
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  </Layout>
                }
              />

              {/* ── Discord Dashboard – standalone routes ── */}
              <Route
                path="/dashboard"
                element={
                  <FeatureGatedRoute featureKey="feature_page_discord_bot">
                    <DiscordDashboard />
                  </FeatureGatedRoute>
                }
              />
              <Route
                path="/dashboard/server/:guildId"
                element={
                  <FeatureGatedRoute featureKey="feature_page_discord_bot">
                    <DiscordServerSettings />
                  </FeatureGatedRoute>
                }
              />

              {/* ── Legacy redirects ── */}
              <Route path="/data-showcase" element={<Navigate to="/price-history" replace />} />
              <Route path="/auth/callback" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </FeatureFlagsProvider>
    </CustomAuthProvider>
  );
}

export default App;
